import { render, staticRenderFns } from "./TaskArchiveList.vue?vue&type=template&id=17314b20"
import script from "./TaskArchiveList.vue?vue&type=script&lang=js"
export * from "./TaskArchiveList.vue?vue&type=script&lang=js"
import style0 from "./TaskArchiveList.vue?vue&type=style&index=0&id=17314b20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports